export default function getLicenseTypeLabel(licenseType) {
    let label;

    switch (licenseType) {
        case 'LICENSE_RESELLER':
            label = 'Reseller';
            break;
        case 'LICENSE_DEFAULT':
            label = 'Default';
            break;
        default:
            label = 'Unknown';
            break;
    }

    return label;
}